import moment from 'moment';
import colors from '../../assets/colors';
import { Dimensions } from '../../common/Contstants';
import Card from '../../components/common/Card';
import CustomButton from '../../components/common/CustomButton';
import Header from '../../components/layout/Header';
import AddStorage, { AddStorageModalProps } from '../../components/modal/AddStorage';
import useModal from '../../hooks/useModal';
import useStorages from '../../hooks/useStorages';
import Storage from '../../types/Storage';

function AllStorages() {
    const { useStoragesListener } = useStorages()
    const { show: showAddStorageModal, ModalComp: AddStorageModal } = useModal<AddStorageModalProps>(({ hide, visible, props }) => <AddStorage hide={hide} props={props} />)

    const { data: storages = [], } = useStoragesListener()

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }} >
            {AddStorageModal}
            <Header
                title='All Storages'
                right={(
                    <CustomButton
                        onClick={showAddStorageModal}
                        containerStyle={{ alignSelf: 'center' }}
                        label='Add Warehouse' />
                )} />
            <div style={{ flex: 1, display: 'grid', flexDirection: 'column', alignItems: 'start', padding: 20, gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gridAutoRows: 'min-content', gridGap: 15, overflowY: 'auto', maxHeight: `calc(100vh - ${Dimensions.header_height}px)` }} >

                {storages.map((item, index) => <StorageItem onClick={() => showAddStorageModal({ storage: item })} key={index} storage={item} />)}

            </div>
        </div>
    );
}

export default AllStorages;

const StorageItem = ({ storage, onClick }: { storage: Storage, onClick: () => void }) => {
    return (
        <Card
            onClick={onClick}
            className='hover-scale'
            style={{ padding: 15, alignItems: 'start', textAlign: 'start', cursor: 'pointer' }} >
            <p style={{ fontWeight: 'bold', marginBottom: 5 }} >{storage.name}</p>
            <p className='truncate' style={{ color: colors.BLACK_60, width: '100%', fontSize: 12, textAlign: 'start' }}  >{storage.location?.address} Branches</p>
            <p style={{ fontSize: 12, padding: '3px 8px 3px 8px', marginTop: 5, backgroundColor: colors.BLACK_10, borderWidth: 1, borderColor: colors.BLACK_20, borderStyle: 'dotted', textAlign: 'start', borderRadius: 2 }} >Created at {moment(storage.created_at).format('YYYY-MM-DD')}</p>
        </Card>
    )
}

